(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('UnitOfMeasure', UnitOfMeasure);

    UnitOfMeasure.$inject = ['$resource'];

    function UnitOfMeasure ($resource) {
        var resourceUrl =  'api/unit-of-measures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
